var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
class LazyImg extends React.Component {
    constructor(props) {
        super(props);
        this.onimgVisible = (visible) => {
            const { src, onError, onLoad } = this.props;
            if (!this.state.isLoaded && visible) {
                this.setState({ isLoaded: true });
                const image = new Image();
                image.src = src;
                image.onerror = (e) => {
                    onError && onError(e);
                };
                image.onload = (_ele) => {
                    this.setState({
                        imgSrc: src,
                    });
                    onLoad && onLoad();
                };
            }
        };
        this.state = {
            imgSrc: props.defaultImgSrc,
            isLoaded: false,
        };
    }
    render() {
        const _a = this.props, { src, defaultImgSrc, style, className, onError, onLoad } = _a, resetProps = __rest(_a, ["src", "defaultImgSrc", "style", "className", "onError", "onLoad"]);
        return <VisibilitySensor active={!this.state.isLoaded} scrollDelay={0} partialVisibility={true} onChange={this.onimgVisible}>
      <img className={className} style={style} src={this.state.imgSrc} {...resetProps}/>
    </VisibilitySensor>;
    }
}
LazyImg.defaultProps = {
    defaultImgSrc: '//f.cfcdn.club/assets/bc4996fadc495c5d722a45872b19f61b_348x348.png',
};
export default LazyImg;



// WEBPACK FOOTER //
// ./components/lazy-img/index.tsx